export function isDownloads(pathname) {
    return pathname === "/downloads";
}

export function isCuratedSets(pathname) {
    return pathname === "/tracks/curated";
}
